import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const withFormikFieldArray = (FieldArrayComponent) => {
   const InnerWithFormikFieldArray = ({ form: formProps, ...restProps }) => {
      const indexedName = restProps.name?.split('.');
      const value = indexedName?.length > 1
         ? formProps.values?.[indexedName[0]]?.[indexedName[1]]?.[indexedName[2]]
         : formProps.values[restProps.name];
      const handleBlur = useCallback(() => {
         formProps.setFieldTouched(restProps.name, true);
      }, [restProps.name, formProps.setFieldTouched]);

      return (
         <FieldArrayComponent
            {
               ...restProps
            }
            value={value}
            handleBlur={handleBlur}
         />
      );
   };

   InnerWithFormikFieldArray.propTypes = {
      form: PropTypes.shape({
         values: PropTypes.objectOf(PropTypes.any),
         setFieldTouched: PropTypes.func.isRequired,
      }).isRequired,
      name: PropTypes.string.isRequired,
   };

   InnerWithFormikFieldArray.defaultProps = {

   };

   return InnerWithFormikFieldArray;
};

export default withFormikFieldArray;
